import app from 'flarum/forum/app';
import GamePage from './components/GamePage';

app.initializers.add('tainted-meridian-backpack-arena', () => {
  app.routes['tm-backpack-arena'] = {
    path: '/game',
    component: GamePage,
  };
});
